import { AccessControlForm } from "@/features/management-settings/forms/access-control-form";
import type { SubjectDto, SubjectDtoType } from "@/spz-api/model";
import { Avatar, AvatarFallback } from "@spz/ui/components/avatar";
import { Typography } from "@spz/ui/components/typography";
import { AccessControlListing } from "./access-control-listing";
interface AccessControlsSheetContentProps {
  subjectName: string;
  subjectId: SubjectDto["id"];
  subjectType: SubjectDtoType;
}

export const AccessControlsSheetContent = ({
  subjectName,
  subjectId,
  subjectType,
}: AccessControlsSheetContentProps) => {
  const [firstName, lastName] = subjectName.split(" ");

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Avatar size={"L"}>
          <AvatarFallback
            size={"L"}
            className="bg-white"
            firstName={firstName}
            lastName={lastName}
          />
        </Avatar>

        <Typography className="text-gray-700 font-semibold">
          {subjectName}
        </Typography>
      </div>

      <AccessControlForm subjectId={subjectId} subjectType={subjectType} />

      <AccessControlListing subjectId={subjectId} subjectType={subjectType} />
    </div>
  );
};
